import React from 'react';
import { usePageMeta } from './shared';

const Privacy: React.FC = () => {
  usePageMeta('Privacy Policy');
  return (
    <>
      <section className="page-head">
        <div className="container">
          <h1>Privacy Policy</h1>
          <p>How Konklave collects, uses, and protects information.</p>
        </div>
      </section>
      <section className="page-body">
        <div className="container">
          <div className="prose">
            <p className="updated">Last updated: June 2026</p>

            <p>
              Konklave (“Konklave,” “we,” “us”) provides a community and operations platform for
              membership organizations. This Privacy Policy explains what information we collect, how
              we use it, and the choices you have. It applies to our marketing website and to the
              branded applications we operate on behalf of organizations (each, an “Organization”).
            </p>

            <h2>Information we collect</h2>
            <ul>
              <li><strong>Information you provide</strong> — such as your name, email, organization, role, and any details you submit through forms (for example, when requesting a demo).</li>
              <li><strong>Member and organization data</strong> — when an Organization uses Konklave, we process member profiles, directory details, events, messages, payments, and related content on that Organization’s behalf.</li>
              <li><strong>Usage and device information</strong> — limited technical data such as IP address, browser type, and pages viewed, used to operate and improve the service.</li>
            </ul>

            <h2>How we use information</h2>
            <ul>
              <li>To provide, secure, and improve the platform and respond to your requests.</li>
              <li>To communicate with you about demos, updates, and support.</li>
              <li>To protect against fraud, abuse, and unauthorized access.</li>
            </ul>

            <h2>How information is shared</h2>
            <p>
              We do not sell personal information. We share information with service providers who help
              us operate the platform (for example, cloud hosting, payment processing, and email
              delivery), and as required by law. Within a branded application, information is shared
              according to the Organization’s settings and access controls.
            </p>

            <h2>Data controlled by Organizations</h2>
            <p>
              For data processed on behalf of an Organization, that Organization is the controller and
              determines how the data is used. Member requests regarding such data should be directed to
              the relevant Organization, and we will assist as needed.
            </p>

            <h2>Security &amp; retention</h2>
            <p>
              We use administrative, technical, and organizational safeguards designed to protect
              information, including access controls and encryption in transit. We retain information for
              as long as needed to provide the service and meet legal obligations.
            </p>

            <h2>Your choices</h2>
            <p>
              You may request access to, correction of, or deletion of personal information we hold about
              you, subject to legal limits. To exercise these rights or ask questions, contact us using
              the details below.
            </p>

            <h2>Contact</h2>
            <p>Questions about this policy? Email <a href="mailto:hello@konklave.app">hello@konklave.app</a> or use the contact form on this site.</p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Privacy;
